import FormNewsletter from '@/components/FormNewsletter'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormNewsletter,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
